/* VINTAGE SCUBA — brand behaviour. Dependency-free, defensive, theme-editor safe. */
(function () {
  'use strict';
  var VS = window.VS || {};
  var root = document.documentElement;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var raf = window.requestAnimationFrame.bind(window);

  /* ---------- helpers ---------- */
  function money(cents) {
    var f = VS.money || '₹{{amount}}';
    var n = (cents / 100);
    var whole = Math.round(n) === n;
    var amt = whole ? n.toLocaleString('en-IN') : n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf('no_decimals') > -1) return Math.round(n).toLocaleString('en-IN');
      return amt;
    });
  }
  function store(key, val) {
    try { if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null'); localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
    return null;
  }
  function waLink(text) { return 'https://wa.me/' + VS.wa + '?text=' + encodeURIComponent(text); }
  function plain(s) { return String(s || '').replace(/<[^>]*>/g, '').trim(); }

  /* ---------- 1. scrolled state (glass header, back-to-top) ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    raf(function () {
      var y = window.scrollY || 0;
      root.toggleAttribute('data-vs-scrolled', y > 60);
      var hero = $('#MainContent > .shopify-section:first-child');
      if (hero && !reduce && y < window.innerHeight * 1.2) {
        var media = $('img, video', hero);
        if (media && hero.matches('[class*="hero"], .shopify-section')) media.style.transform = 'translate3d(0,' + (y * 0.12).toFixed(1) + 'px,0) scale(1.06)';
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- 2. scroll reveal ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vs-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  var REVEAL = [
    '.product-grid > *', '.resource-list__item', '.vs-feature', '.vs-faq details', '.collection-card', '.vs-wish-grid > *',
    '#MainContent .shopify-section:not(:first-child) .section-content-wrapper > *', 'footer .section-content-wrapper > *'
  ].join(',');

  function armReveal(scope) {
    if (!io || reduce || root.classList.contains('shopify-design-mode')) return;
    var vh = window.innerHeight;
    $$(REVEAL, scope).forEach(function (el, i) {
      if (el.dataset.vsArmed) return;
      el.dataset.vsArmed = '1';
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) return; // already visible: leave alone
      el.style.setProperty('--vs-i', i % 6);
      el.classList.add('vs-reveal');
      io.observe(el);
    });
  }

  /* ---------- 3. wishlist ---------- */
  var WL_KEY = 'vs-wishlist';
  function wl() { return store(WL_KEY) || []; }
  function wlHas(h) { return wl().indexOf(h) > -1; }
  function wlToggle(h) {
    var l = wl(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.push(h);
    store(WL_KEY, l);
    $$('[data-vs-wish="' + h + '"]').forEach(function (b) { b.setAttribute('aria-pressed', String(i === -1)); });
    document.dispatchEvent(new CustomEvent('vs:wishlist', { detail: { handles: l } }));
    return i === -1;
  }
  function handleFrom(card) {
    var a = $('a[href*="/products/"]', card);
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function heartify(scope) {
    if (VS.wishlist === false) return;
    $$('product-card, .product-card', scope).forEach(function (card) {
      var g = $('.card-gallery', card);
      if (!g || $('.vs-heart', g)) return;
      var h = handleFrom(card); if (!h) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'vs-heart vs-glass vs-press';
      b.setAttribute('data-vs-wish', h);
      b.setAttribute('aria-label', 'Save to wishlist');
      b.setAttribute('aria-pressed', String(wlHas(h)));
      b.innerHTML = '<svg viewBox="0 0 24 24"><path stroke-linejoin="round" d="M12 20.5s-7.5-4.6-9.2-9.4C1.7 7.9 3.6 4.5 7 4.5c2 0 3.5 1.1 5 3 1.5-1.9 3-3 5-3 3.4 0 5.3 3.4 4.2 6.6-1.7 4.8-9.2 9.4-9.2 9.4z"/></svg>';
      g.appendChild(b);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vs-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    wlToggle(b.getAttribute('data-vs-wish'));
  }, true);

  /* wishlist page renderer */
  function renderWishlist() {
    var box = $('[data-vs-wishlist-grid]'); if (!box) return;
    var handles = wl();
    var empty = $('[data-vs-wishlist-empty]');
    box.innerHTML = '';
    if (empty) empty.hidden = handles.length > 0;
    handles.forEach(function (h) {
      fetch((VS.root || '/') + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_700x$1$2') : '';
        var a = document.createElement('a');
        a.className = 'vs-wish-card'; a.href = p.url;
        a.innerHTML = '<div class="vs-wish-card__img">' + (img ? '<img loading="lazy" alt="" src="' + img + '">' : '') +
          (p.available ? '' : '<span class="vs-chip vs-wish-card__sold">Gone</span>') + '</div>' +
          '<div class="vs-wish-card__meta"><span>' + plain(p.title) + '</span><span class="vs-mono">' + money(p.price) + '</span></div>';
        box.appendChild(a);
        armReveal(box);
      });
    });
  }
  document.addEventListener('vs:wishlist', function () { if ($('[data-vs-wishlist-grid]')) renderWishlist(); });

  /* ---------- 4. WhatsApp: cart checkout ---------- */
  function buildCartMessage(cart) {
    var lines = [VS.greeting || 'Hey! I want to order:', ''];
    cart.items.forEach(function (it, i) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? ' (' + it.variant_title + ')' : '';
      lines.push((i + 1) + '. ' + it.product_title + variant + ' × ' + it.quantity + ' — ' + money(it.final_line_price));
      lines.push('   ' + location.origin + it.url.split('?')[0]);
    });
    lines.push('', 'Total: ' + money(cart.total_price));
    if (cart.note) lines.push('Note: ' + cart.note);
    lines.push('', 'My details 👇', 'Name:', 'Address:', 'Pincode:', 'Payment (UPI / COD):');
    return lines.join('\n');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vs-wa-checkout]');
    if (!btn) return;
    e.preventDefault();
    var win = window.open('about:blank', '_blank'); // open synchronously so iOS/Safari doesn't block it
    btn.setAttribute('aria-busy', 'true');
    fetch((VS.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { if (win) win.close(); return; }
        var url = waLink(buildCartMessage(cart));
        if (win) win.location.href = url; else location.href = url;
      })
      .catch(function () { if (win) win.close(); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- 5. product page: variant-aware WhatsApp + stock ---------- */
  function currentVariant(wrap) {
    var data = $('[data-vs-variants]', wrap); if (!data) return null;
    var variants = []; try { variants = JSON.parse(data.textContent); } catch (e) {}
    var form = $('product-form-component input[name="id"]') || $('form[action*="/cart/add"] input[name="id"]');
    var id = (form && form.value) || new URLSearchParams(location.search).get('variant');
    return variants.filter(function (v) { return String(v.id) === String(id); })[0] || variants[0] || null;
  }
  function refreshExtras() {
    $$('[data-vs-extras]').forEach(function (wrap) {
      var v = currentVariant(wrap); if (!v) return;
      var s = $('[data-vs-stock]', wrap);
      if (s) {
        var cls = 'vs-stock'; var txt;
        if (!v.available) { cls += ' vs-stock--gone'; txt = wrap.dataset.soldText || 'Sold Out'; }
        else if (v.qty > 0 && v.qty <= (VS.lowStock || 2)) { txt = v.qty === 1 ? 'Only 1 Left — One Of One' : 'Only ' + v.qty + ' Left'; }
        else { cls += ' vs-stock--ok'; txt = 'In Stock'; }
        s.className = cls; s.textContent = txt;
      }
      var wa = $('[data-vs-wa-product]', wrap);
      if (wa) wa.disabled = !v.available;
    });
  }
  document.addEventListener('variant:update', function () { setTimeout(refreshExtras, 30); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vs-wa-product]'); if (!b) return;
    var wrap = b.closest('[data-vs-extras]'); var v = currentVariant(wrap); if (!v) return;
    var title = wrap.dataset.title;
    var vt = v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '';
    var url = location.origin + wrap.dataset.url + (v.id ? '?variant=' + v.id : '');
    var msg = (VS.greeting || 'Hey! I want to order:') + '\n\n1. ' + title + vt + ' — ' + money(v.price) + '\n' + url +
      '\n\nMy details 👇\nName:\nAddress:\nPincode:\nPayment (UPI / COD):';
    window.open(waLink(msg), '_blank');
  });

  /* ---------- 6. juice: magnetic buttons + tilt cards with moving sheen ---------- */
  if (fine && !reduce) {
    document.addEventListener('pointermove', function (e) {
      var t = e.target.closest && e.target.closest('.button, .vs-wa-btn, .vs-chip, .vs-wa-float');
      if (t) {
        var r = t.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width, y = (e.clientY - r.top - r.height / 2) / r.height;
        t.style.translate = (x * 8).toFixed(1) + 'px ' + (y * 6).toFixed(1) + 'px';
        t.__vsMag = true;
      }
      var c = e.target.closest && e.target.closest('product-card .card-gallery');
      if (c) {
        var cr = c.getBoundingClientRect();
        var px = (e.clientX - cr.left) / cr.width, py = (e.clientY - cr.top) / cr.height;
        c.style.transform = 'perspective(900px) rotateX(' + ((0.5 - py) * 5).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 6).toFixed(2) + 'deg)';
        c.style.setProperty('--vs-mx', (px * 100) + '%'); c.style.setProperty('--vs-my', (py * 100) + '%');
        c.classList.add('vs-tilt');
      }
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var t = e.target.closest && e.target.closest('.button, .vs-wa-btn, .vs-chip, .vs-wa-float');
      if (t && t.__vsMag) { t.style.translate = ''; t.__vsMag = false; }
      var c = e.target.closest && e.target.closest('product-card .card-gallery');
      if (c && !c.contains(e.relatedTarget)) { c.style.transform = ''; c.classList.remove('vs-tilt'); }
    }, { passive: true });
  }

  /* ---------- 7. count-up numbers ([data-vs-count]) ---------- */
  function countUp(scope) {
    $$('[data-vs-count]', scope).forEach(function (el) {
      if (el.dataset.vsDone) return; el.dataset.vsDone = '1';
      var to = parseFloat(el.dataset.vsCount) || 0, dur = 1400, t0 = null;
      if (reduce || !io) { el.textContent = to; return; }
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; o.disconnect();
        (function step(t) { t0 = t0 || t; var k = Math.min(1, (t - t0) / dur); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 4))); if (k < 1) raf(step); })(performance.now());
      }); o.observe(el);
    });
  }

  /* ---------- boot + re-run when sections/pagination/filters swap in ---------- */
  function boot(scope) { heartify(scope); armReveal(scope); countUp(scope); refreshExtras(); }
  boot(document);
  renderWishlist();

  var mo, pending = false;
  if ('MutationObserver' in window) {
    mo = new MutationObserver(function () {
      if (pending) return; pending = true;
      raf(function () { pending = false; boot(document); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });


  /* ---------- CHANGE: Hero mute/unmute + compact section toggles ---------- */
  function initHeroMute() {
    $$('[data-vs-hero-video]').forEach(function (wrap) {
      if (wrap.querySelector('.vs-hero-mute')) return;
      var video = $('video', wrap);
      if (!video) return;
      video.setAttribute('playsinline', '');
      video.muted = true;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vs-hero-mute';
      btn.setAttribute('aria-label', 'Unmute video');
      btn.setAttribute('data-muted', 'true');
      btn.innerHTML =
        '<svg class="vs-icon-muted" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M11 5 6 9H3v6h3l5 4V5z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
        '<path d="m16 9 5 5M21 9l-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '</svg>' +
        '<svg class="vs-icon-unmuted" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M11 5 6 9H3v6h3l5 4V5z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
        '<path d="M15.5 8.5a5 5 0 0 1 0 7M18 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '</svg>';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willUnmute = video.muted;
        video.muted = !willUnmute;
        if (willUnmute) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
        btn.setAttribute('data-muted', video.muted ? 'true' : 'false');
        btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });

      wrap.appendChild(btn);
    });
  }

  function initCompactSections() {
    $$('[data-vs-compact-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var bodyId = btn.getAttribute('aria-controls');
      var body = bodyId ? document.getElementById(bodyId) : null;
      if (!body) body = btn.parentElement && btn.parentElement.querySelector('[data-vs-compact-body]');
      if (!body) return;

      function syncForViewport() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          body.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      }
      syncForViewport();
      window.addEventListener('resize', syncForViewport);

      btn.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        body.hidden = open;
        var label = $('[data-vs-compact-label]', btn);
        if (label) {
          var isLookbook = (body.id || '').indexOf('lookbook') !== -1;
          var isReviews = (body.id || '').indexOf('testimonials') !== -1;
          if (open) {
            label.textContent = isLookbook ? 'Tap to view Lookbook' : isReviews ? 'Tap to view Reviews' : 'Tap to expand';
          } else {
            label.textContent = 'Tap to collapse';
          }
        }
      });
    });
  }

  initHeroMute();
  initCompactSections();
  document.addEventListener('shopify:section:load', function () {
    initHeroMute();
    initCompactSections();
  });

})();
